module.exports = __webpack_public_path__ + "static/media/setupWarning.4dde6985.svg";